import { Typography } from '@mui/material'
import {
  BlurredContainer,
  CaseStudyContainer,
  CaseStudyImageWrapper,
  Container,
  GatedContainerTitle,
  InfoWrapper,
  MainBody,
} from './styled'
import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import GatedForm from './GatedForm'
import Image from 'next/image'
import { useQuery } from 'react-query'
import ConstanceApi from 'api/ConstanceApi'

const CaseStudy = ({ project }: IProjectContextSectionProps) => {
  const [isBlocked, setIsBlocked] = useState(true)

  const { data: portalId } = useQuery({
    queryKey: ['portalId'],
    queryFn: () => ConstanceApi.getConstance('HUBSPOT_FORM_PORTAL_ID'),
  })

  const { data: formId } = useQuery({
    queryKey: ['formId'],
    queryFn: () => ConstanceApi.getConstance('HUBSPOT_GATED_CONTENT_FORM_ID'),
  })

  useEffect(() => {
    const cookieExists = Cookies.get('canViewCaseStudy')
    if (cookieExists) {
      setIsBlocked(false)
    }
  }, [])

  const handleCreateCookie = () => {
    Cookies.set('canViewCaseStudy', 'true', { expires: 36500 })
    setIsBlocked(false)
  }

  const renderGatedForm = () => {
    if (formId && formId.length > 0 && portalId && portalId.length > 0) {
      return (
        <GatedForm
          portalId={portalId[0].value as string}
          formId={formId[0].value as string}
          onSubmitCallback={handleCreateCookie}
        />
      )
    }
  }

  if (!project.caseStudy) {
    return null
  }

  return (
    <Container>
      <BlurredContainer isBlocked={isBlocked}>
        <InfoWrapper>
          <GatedContainerTitle>Case study: {project?.caseStudy?.title}</GatedContainerTitle>
          <Typography variant="body1">Want to access this content?</Typography>
          <Typography variant="body1">Please enter your informations to unlock:</Typography>

          {renderGatedForm()}
        </InfoWrapper>
      </BlurredContainer>

      <CaseStudyContainer isBlocked={isBlocked}>
        <Typography variant="h3">{project?.caseStudy?.title}</Typography>
        <CaseStudyImageWrapper>
          <Image
            src={project?.caseStudy?.headerImage?.fullSize}
            alt={project?.caseStudy?.title || ''}
            layout="fill"
            objectFit="cover"
          />
        </CaseStudyImageWrapper>
        <Typography variant="h5">{project?.caseStudy?.title}</Typography>
        <MainBody>
          <div dangerouslySetInnerHTML={{ __html: project?.caseStudy?.body }} />
        </MainBody>
        {project.caseStudy.sections.map((section) => (
          <>
            <Typography variant="h5">{section.title}</Typography>

            <MainBody>
              <div dangerouslySetInnerHTML={{ __html: section?.body }} />
            </MainBody>
          </>
        ))}
      </CaseStudyContainer>
    </Container>
  )
}

export default CaseStudy
